
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/docs-restructure-2022",
      function () {
        return require("private-next-pages/blog/docs-restructure-2022.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/docs-restructure-2022"])
      });
    }
  